import React from 'react';
import { useTranslation } from 'react-i18next';
import { DiaryHomeTasks } from '@/components/DiaryHomeTasks';
import { HomeTaskAttachments } from '@/components/HomeTaskModal/HomeTaskAttachments';
import { AuthorInfo } from '@/components/LessonDetailsModal/AuthorInfo';
import { DETAILS_CARD } from '@/components/LessonDetailsModal/classNames';
import type { Attachment } from '@/types/attachment';
import { AttachmentsDisplay } from '@/types/components';
import type { DiaryLesson } from '@/types/diary';

interface Props {
  lesson: DiaryLesson;
  onPreview: (attachment: Attachment) => void;
  onOpenHomeTask: (homeTaskId: number) => void;
}

export const LessonHomeworkCards: React.FC<Props> = ({
  lesson,
  onPreview,
  onOpenHomeTask,
}) => {
  const { t } = useTranslation();

  const { homeTasks, thirdPartyEvents } = lesson;
  const hasHomework = homeTasks.length > 0 || thirdPartyEvents.length > 0;

  return (
    <>
      {homeTasks.map((homeTask) => (
        <div
          key={homeTask.id}
          className={`flex flex-col gap-3 ${DETAILS_CARD}`}
        >
          <DiaryHomeTasks
            isFullText
            homeTasks={[homeTask]}
            attachmentsDisplay={AttachmentsDisplay.Hidden}
            className="text-body-14 text-foreground"
            onOpenHomeTask={onOpenHomeTask}
          />
          {!homeTask.areAnswersEnabled && (
            <HomeTaskAttachments
              isFullWidth
              attachments={homeTask.attachments}
              onPreview={onPreview}
            />
          )}
          <AuthorInfo
            authorName={homeTask.authorName}
            timeCreated={homeTask.timeCreated}
            lastModification={homeTask.lastModification}
          />
        </div>
      ))}
      {thirdPartyEvents.map((event) => (
        <div key={event.url} className={`flex flex-col gap-3 ${DETAILS_CARD}`}>
          <DiaryHomeTasks
            homeTasks={[]}
            thirdPartyEvents={[event]}
            className="text-body-14 text-foreground"
          />
          <AuthorInfo
            authorName={event.lastModification.authorName}
            timeCreated={event.lastModification.timeModified}
            lastModification={null}
          />
        </div>
      ))}
      {!hasHomework && (
        <p className={`text-body-14 text-foreground ${DETAILS_CARD}`}>
          {t('diary.emptyDescription')}
        </p>
      )}
    </>
  );
};
